import { defineComponent as _defineComponent } from 'vue'
import SportWatchNowButton from '@/features/sports/components/ui/SportWatchNowButton.vue';
import CompetitorLogo from '@/features/sports/components/ui/CompetitorLogo.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import GameEventStatus from '@/features/sports/components/ui/GameEventStatus.vue';

import {
	MultiStepSportEvent,
	ObjectType,
	SingleStepSportEvent,
	SportEventStatus,
	SportOffer,
} from '@/@types/graphql-types';

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { BuyboxParam } from '@/helpers/offer-helper';
import { SingleStepContext } from '@/features/sports/helpers/config';
import { SnowplowContext, SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { faBell } from '@fortawesome/free-solid-svg-icons';

import { useSportsNotification } from '@/features/sports/composables/useSportsNotification';

import { storeToRefs } from 'pinia';
import { useAppStore } from '@/stores/pinia/useAppStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useUserStore } from '@/stores/pinia/useUserStore';

import { useI18n } from '@/helpers/composables/useI18n';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleStepEventLineup',
  props: {
    displayOffer: { type: Boolean },
    kickoffDate: { default: '' },
    kickoffTime: { default: '' },
    context: null,
    event: null,
    additionalContexts: { default: () => [] }
  },
  emits: ["clickOut"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'clickOut', data: { offer: SportOffer; index: number | undefined }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { displayOffer: boolean, kickoffDate: string, kickoffTime: string, context: SingleStepContext, event: SingleStepSportEvent, additionalContexts: SnowplowContext[] };





const { tc } = useI18n();

const { country, webLocale } = storeToRefs(useLanguageStore());

const { xServeTrack } = storeToRefs(useAppStore());

const { isLoggedIn } = storeToRefs(useUserStore());

const competitors = computed(() => props.context.getCompetitors(props.event, webLocale.value));

const isDoublesEvent = computed(() => competitors.value.start.length === 2 && competitors.value.end.length === 2);

const eventStatus = computed(() => props.event.content?.status);
const notStarted = computed(() => eventStatus.value === SportEventStatus.NotStarted);
const isEnded = computed(() => eventStatus.value === SportEventStatus.Closed);
const isLive = computed(() => eventStatus.value === SportEventStatus.Live);

const watchNowContent = computed(() =>
	isLive.value ? tc('SPORTS_WEBAPP_WATCH_LIVE') : tc('SPORTS_WEBAPP_WATCH_HIGHLIGHTS')
);

const gameStatusContent = computed(() => (isEnded.value ? tc('SPORTS_WEBAPP_FULL_TIME') : tc('SPORTS_WEBAPP_LIVE')));

const showWatchNow = computed(() => !notStarted.value && props.displayOffer);

const showNotifyMe = computed(() => notStarted.value && props.displayOffer);

const offerClickoutUrl = computed(() =>
	new ClickoutUrl(props.event.watchNowOffer)
		.addContexts(props.additionalContexts)
		.set('uct_country', country.value)
		.set('uct_buybox', BuyboxParam.Sport)
		.set('uct_sport', props.event.sport)
		.setCanary(xServeTrack.value)
);

const showScore = computed(
	() => competitors.value.start[0].score !== null && competitors.value.end[0].score !== null && isEnded.value
);

const isNotificationActive = computed(() => !!props.event.mysportlistEntry?.createdAt);

function handleClickOut() {
	return emits('clickOut', { offer: props.event.watchNowOffer!, index: undefined });
}

const { toggleMySportsNotification } = useSportsNotification();
async function notifyMe(event: SingleStepSportEvent | MultiStepSportEvent) {
	await toggleMySportsNotification(
		{
			eventId: props.event.id,
			isNotificationActive: !!props.event.mysportlistEntry?.createdAt,
		},
		isLoggedIn.value
	);

	const sportContext = SnowplowSportContext.fromSportEventV2(event.sport, ObjectType.SportEvent, event);
	TrackingHelper.trackEvent('userinteraction', { action: 'notify_me_clicked' }, [sportContext]);
}

return { __sfc: true,props, emits, tc, country, webLocale, xServeTrack, isLoggedIn, competitors, isDoublesEvent, eventStatus, notStarted, isEnded, isLive, watchNowContent, gameStatusContent, showWatchNow, showNotifyMe, offerClickoutUrl, showScore, isNotificationActive, handleClickOut, toggleMySportsNotification, notifyMe, SportWatchNowButton, CompetitorLogo, BasicButton, GameEventStatus, faBell }
}

})